import React from "react";

const About = () => {
  return (
    <div className="w-full h-full bg-gradient-to-b from-amber-50 to-white">
      {/* Hero Section */}
      <div className="w-full md:h-[60dvh] h-[40dvh] relative flex items-center justify-center about bg-gradient-to-r from-amber-100 to-yellow-100">
        <div className="text-center z-10">
          {/* <h1 className="text-[#645f14] text-5xl md:text-6xl font-light mb-4">About Jasmin</h1> */}
          {/* <div className="w-24 h-1 bg-[#645f14] mx-auto opacity-60"></div> */}
        </div>
      </div>

      {/* Main Content */}
      <div className="w-full px-5 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Introduction */}
          <div className="text-center mb-16">
            <p className="md:text-xl text-lg font-light text-gray-700 leading-relaxed mb-8">
              Welcome to a journey of self-discovery and inner freedom through the practice of yoga. 
              My passion for yoga began at the age of 14, when I first embraced the transformative 
              power of meditation. Since then, yoga has become a cornerstone of my life—a tool I use 
              and teach to help others navigate the complexities of life with grace, balance, and authenticity.
            </p>
            <p className="md:text-xl text-lg font-light text-gray-700 leading-relaxed">
              I believe that yoga is for everyone, regardless of age, experience, background, or physical ability. a
              It's a path that invites you to peel away the layers of stress, doubt, and limitations, revealing 
              your truest self. In my teaching, I emphasize that yoga is not just about poses—it's about finding 
              connection within, living more freely, and embracing each moment with awareness.
            </p>
          </div>

          {/* Qualifications Section */}
          <div className="bg-white rounded-lg shadow-lg p-8 mb-16">
            <h2 className="text-3xl text-[#645f14] text-center mb-8 font-light">Qualifications & Training</h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Having trained extensively across the globe, including more than a dozen trips to India, 
              I have deepened my practice and understanding of yoga through various disciplines.
            </p>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#645f14] rounded-full mt-3 flex-shrink-0"></div>
                  <p className="text-gray-700">200-hour Yoga Teacher Training with Yogalife International in Brussels, Belgium</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#645f14] rounded-full mt-3 flex-shrink-0"></div>
                  <p className="text-gray-700">60-hour Pranayama Certification in Ibiza, Spain</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#645f14] rounded-full mt-3 flex-shrink-0"></div>
                  <p className="text-gray-700">40-hour Yoga Nidra Certification in Brussels, Belgium</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#645f14] rounded-full mt-3 flex-shrink-0"></div>
                  <p className="text-gray-700">100-hour Sadhana in Antastha Yoga (Blindfold Yoga) in Ibiza, Spain</p>
                </div>
              </div>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#645f14] rounded-full mt-3 flex-shrink-0"></div>
                  <p className="text-gray-700">20-hour Yin Yoga training Hamilton, Canada</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#645f14] rounded-full mt-3 flex-shrink-0"></div>
                  <p className="text-gray-700">8 hours Yoga alignment principles and practice Montreal, Quebec</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#645f14] rounded-full mt-3 flex-shrink-0"></div>
                  <p className="text-gray-700">8 hours of Chair Yoga Teacher Training Hamilton, Canada</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-[#645f14] rounded-full mt-3 flex-shrink-0"></div>
                  <p className="text-gray-700">50-hour Hands-on Workshop in Goa, India</p>
                </div>
              </div>
            </div>
          </div>

          {/* Experience Section */}
          <div className="bg-gradient-to-r from-amber-50 to-yellow-50 rounded-lg p-8 mb-16">
            <h2 className="text-3xl text-[#645f14] text-center mb-6 font-light">Experience & Teaching</h2>
            <p className="md:text-lg text-gray-700 leading-relaxed text-center">
              Each year, I have the privilege of co-hosting a transformative retreat in India with 
              Yogalife International, where I guide participants through a deeply immersive experience, 
              helping them reconnect with themselves and explore their potential. My ongoing training 
              with Yogalife, as well as other global and local institutions, reflects my commitment 
              to continually grow and evolve as a teacher.
            </p>
          </div>

          {/* Closing Message */}
          <div className="text-center">
            <p className="md:text-lg text-gray-700 leading-relaxed mb-8">
              My teaching comes from the heart, infused with the wisdom gained from my personal journey 
              and the rich traditions of my partial roots in India. I invite you to join me on the mat, 
              where together, we can explore the path of yoga as a means to live more freely, with 
              greater joy, peace, and connection.
            </p>
            
            <div className="inline-block">
              <p className="text-2xl text-[#645f14] font-light italic">Love & Appreciation</p>
              <div className="w-16 h-1 bg-[#645f14] mx-auto mt-2 opacity-60"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;